import { render, staticRenderFns } from "./AccountSecurity.vue?vue&type=template&id=c4557b06&scoped=true"
import script from "./AccountSecurity.vue?vue&type=script&lang=js"
export * from "./AccountSecurity.vue?vue&type=script&lang=js"
import style0 from "./AccountSecurity.vue?vue&type=style&index=0&id=c4557b06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4557b06",
  null
  
)

export default component.exports